import { ModalData } from "store/features/modalSlice";

import DefaultImage from "assets/images/landing/default.jpg";

export const ONBOARDING_MODAL_CONTENT: ModalData = {
  featureId: "1",
  title: "Створюємо платіжне посилання разом",
  content: "Перегляньте коротке відео, як створити своє перше посилання.",
  videoUrl: "embed/cEjr4OKUz-o",
  videoUrlMobile: "shorts/28_uNHk0yOI",
  imageUrl: DefaultImage,
};
